import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { MAX_KEYWORD_LENGTH } from '../../../helpers/booleanValidator';
import KeywordFilter from '../../atoms/KeywordFilter';
import SeniorityMultiSelect from '../../atoms/SeniorityMultiSelect';
import { ApiFacet } from '../../molecules/filters/apiFacet';
import { LocationFilter } from '../../molecules/filters/location';
import YearsOfExperienceFilter from '../../molecules/filters/yearsOfExperience';
import { ContactOfFilter } from '../../molecules/filters/contactOf';
import { JobTitle } from '../../molecules/filters/jobTitle';
import { SharedList } from '../../molecules/filters/sharedListFilters';

export const Filters = ({ sharedList, filters, filterCount, setFilters, showListFilters }) => (
  <Flex
    flexGrow="1"
    alignItems="flex-end"
    pb={filterCount > 0 ? '72px' : 0}
    sx={{
      gap: '4px',
      flexWrap: 'wrap',
    }}
  >
    <Box width="100%" py="8px" data-testid="contact-filters-keywords">
      <KeywordFilter
        value={filters.keywords}
        onChange={(value) => setFilters({ keywords: value })}
        maxEntryLength={MAX_KEYWORD_LENGTH}
      />
    </Box>
    <Flex width="100%" pt="8px" data-testid="contact-filters-job-titles">
      <JobTitle filters={filters} setFilters={setFilters} sharedList={sharedList} showListFilters={showListFilters} />
    </Flex>
    <Box width="100%" pt="8px" data-testid="contact-filters-location">
      <LocationFilter
        locationRadius={filters.locationRadius}
        value={filters.locationIds}
        setFilters={setFilters}
        showRadius
      />
    </Box>
    <Box width="100%" pt="8px">
      <SeniorityMultiSelect value={filters.workExperiencesSeniority} setFilters={setFilters} />
    </Box>
    {showListFilters && (
      <Box width="100%" pt="8px" data-testid="contact-filters-shared-lists-ids">
        <SharedList value={filters.sharedListIds} onChange={(value) => setFilters({ sharedListIds: value })} />
      </Box>
    )}
    <Box width="100%" pt="8px" data-testid="contact-filters-tags">
      <ApiFacet
        name="tags"
        label="Tags"
        value={filters.tags}
        onChange={(value) => setFilters({ tags: value })}
        notFoundText="No tag"
        orderBy="alpha"
        sharedList={sharedList}
        useShareListFilter={!showListFilters}
        useInitialOpenDropDown
      />
    </Box>
    <Box width="100%" pt="8px" data-testid="contact-filters-importer-ids">
      <ContactOfFilter value={filters.importerIds} onChange={(value) => setFilters({ importerIds: value })} />
    </Box>
    <Box width="100%" py="8px" data-testid="contact-filters-years-experience">
      <YearsOfExperienceFilter
        label="Years of experience"
        name="years_experience"
        min={0}
        max={41}
        yearsOfExperience={filters.yearsOfExperience}
        onYearsOfExperienceChange={(value) => setFilters({ yearsOfExperience: value })}
      />
    </Box>
    <Box width="100%" py="8px" data-testid="contact-filters-years-in-current-company">
      <YearsOfExperienceFilter
        label="Years in current company"
        name="years_in_current_company"
        min={0}
        max={41}
        yearsOfExperience={filters.yearsInCurrentCompany}
        onYearsOfExperienceChange={(value) => setFilters({ yearsInCurrentCompany: value })}
      />
    </Box>
  </Flex>
);

Filters.propTypes = {
  sharedList: PropTypes.object,
  filters: PropTypes.object.isRequired,
  filterCount: PropTypes.number,
  setFilters: PropTypes.func.isRequired,
  showListFilters: PropTypes.bool.isRequired,
};

Filters.defaultProps = {
  filterCount: 0,
  sharedList: null,
};
